import { render, staticRenderFns } from "./AIMicroFlyer.vue?vue&type=template&id=a5701d06&scoped=true&"
import script from "./AIMicroFlyer.vue?vue&type=script&lang=js&"
export * from "./AIMicroFlyer.vue?vue&type=script&lang=js&"
import style0 from "./AIMicroFlyer.vue?vue&type=style&index=0&id=a5701d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5701d06",
  null
  
)

export default component.exports